import React, { useEffect, useState } from 'react';
import { Card, Badge, Button, FadeIn } from '../components/ui';
import { rupee } from '../theme';
import { useAuth } from '../context/AuthContext';
import api from '../api/client';
import { demoPackages } from '../api/demo';

// Base price is common for all areas.
export function priceFor(pkg) {
  return { price: pkg.price, discountPrice: pkg.discountPrice };
}

// Region-wise total service charge (incl GST); falls back to the package default.
export function serviceChargeFor(pkg, locationName) {
  const row = (pkg.locationPricing || []).find((r) => r.location === locationName);
  if (row && row.serviceCharge != null && row.serviceCharge !== '') return Number(row.serviceCharge) || 0;
  return Number(pkg.serviceCharge) || 0;
}

export default function Packages({ onBook }) {
  const { selectedLocation } = useAuth();
  const [packages, setPackages] = useState(demoPackages);
  const locName = selectedLocation?.name;

  useEffect(() => {
    let alive = true;
    api.get('/packages?active=true')
      .then((d) => { if (alive && d?.packages?.length) setPackages(d.packages); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return (
    <div className="screen">
      <div className="page-head">
        <h1>Packages</h1>
        <p>
          {selectedLocation
            ? `Prices for 📍 ${[selectedLocation.name, selectedLocation.city].filter(Boolean).join(', ')}`
            : 'Choose a plan that fits your home'}
        </p>
      </div>

      <div className="pkg-grid">
        {packages.map((p, i) => {
          const pr = priceFor(p, locName);
          const svc = serviceChargeFor(p, locName);
          return (
            <FadeIn key={p._id} delay={i * 60}>
              <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <div className="row-between" style={{ alignItems: 'flex-start' }}>
                  <div className="grow">
                    <Badge label={p.category} tone="brand" />
                    <div style={{ fontSize: 17, fontWeight: 800, marginTop: 8 }}>{p.title}</div>
                  </div>
                  {p.isPopular && <Badge label="★ Popular" tone="warning" />}
                </div>

                <div className="row wrap" style={{ alignItems: 'baseline', gap: 8, marginTop: 6 }}>
                  <span className="price">{rupee(pr.discountPrice || pr.price)}</span>
                  {pr.discountPrice ? <span className="strike">{rupee(pr.price)}</span> : null}
                  <span className="muted" style={{ fontSize: 12.5 }}>/ {p.durationType}</span>
                  {svc > 0 && (
                    <span style={{ fontSize: 12, color: 'var(--success)', fontWeight: 700 }}>
                      + {rupee(svc)} service charge (incl GST)
                    </span>
                  )}
                </div>

                <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {(p.features || []).map((f) => (
                    <span key={f} className="muted" style={{ fontSize: 13.5 }}>✓ {f}</span>
                  ))}
                </div>

                {p.locations?.length > 0 && (
                  <div className="row wrap" style={{ gap: 6, marginTop: 12 }}>
                    {p.locations.map((l) => (
                      <span key={l} style={{
                        background: 'var(--bg)', borderRadius: 'var(--r-pill)', padding: '4px 10px',
                        fontSize: 11.5, color: 'var(--muted)', fontWeight: 600,
                      }}>📍 {l}</span>
                    ))}
                  </div>
                )}

                <div style={{ marginTop: 'auto', paddingTop: 16 }}>
                  <Button title="Book Now" onClick={() => onBook && onBook(p)} />
                </div>
              </Card>
            </FadeIn>
          );
        })}
      </div>
    </div>
  );
}
